<template>
  <div class="marketing-view workbench-body">
    <div class="workbench-body-left">
      <div class="briefing">
        <mk-card>
          <div
            slot="header"
            class="card-header"
          >
            <div>
              数据总览
              <mk-popover
                class="h-title"
                placement="left"
                trigger="hover"
                reference=""
              >
                <div class="h-t-popover">
                  <span>浏览量（PV）：</span>
                  即⻚⾯浏览量，⽤户每次刷新即被计算⼀次。<br />
                  <span>浏览人数（UV）：</span>
                  即页面浏览人数 。每⽇（00:00-24:00）<br />内相同的访客只被计算⼀次。
                </div>
                <template slot="reference">
                  <mk-iconfont
                    class="icon"
                    icon-class="question-mark"
                    style="color:#888; cursor: pointer; font-weight: normal;"
                  ></mk-iconfont>
                </template>
              </mk-popover>
            </div>

            <mk-radio-group v-model="dataType">
              <mk-radio-button label="all">
                累计
              </mk-radio-button>
              <mk-radio-button label="yesterday">
                昨日新增
              </mk-radio-button>
            </mk-radio-group>
          </div>
          <div class="briefing-body">
            <template v-if="dataType === 'all'">
              <!-- <div class="briefing-item">
                <div class="briefing-count">
                  {{ briefingData.countUVTotal || 0 }}
                </div>
                <div class="briefing-type">
                  <span>营销资料访问线索（UV）</span>
                  <span>日新增
                    <span class="highlight">
                      {{ briefingData.countUVNew || 0 }}
                    </span></span>
                </div>
              </div> -->
              <div class="briefing-item">
                <div class="briefing-count">
                  {{ briefingData.countPVTotal || 0 }}
                </div>
                <div class="briefing-type">
                  <span>营销资料浏览量（PV）</span>
                  <span>日新增
                    <span class="highlight">{{
                      briefingData.countPVNew || 0
                    }}</span></span>
                </div>
              </div>
              <div class="line"></div>
              <div class="briefing-item">
                <div class="briefing-count">
                  {{ briefingData.countUVTotal || 0 }}
                </div>
                <div class="briefing-type">
                  <span>营销资料浏览人数（UV）</span>
                  <span>日新增
                    <span class="highlight">
                      {{ briefingData.countUVNew || 0 }}
                    </span></span>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="briefing-item">
                <div class="briefing-count">
                  {{ briefingData.countPVYesterday || 0 }}
                </div>
                <div class="briefing-type">
                  <span>营销资料浏览量（PV）</span>
                </div>
              </div>
              <div class="line"></div>
              <div class="briefing-item">
                <div class="briefing-count">
                  {{ briefingData.countUVYesterday || 0 }}
                </div>
                <div class="briefing-type">
                  <span>营销资料浏览人数（UV）</span>
                </div>
              </div>
            </template>
          </div>
        </mk-card>
      </div>
      <div class="chart">
        <mk-card>
          <div
            slot="header"
            class="card-header"
          >
            <span>数据趋势</span>
            <mk-radio-group
              v-model="chartType"
              @change="onChartTypeChange"
            >
              <mk-radio-button label="month">
                月
              </mk-radio-button>
              <mk-radio-button label="week">
                周
              </mk-radio-button>
              <mk-radio-button label="day">
                日
              </mk-radio-button>
            </mk-radio-group>
          </div>
          <div class="chart-body">
            <template v-if="chartList.length > 0">
              <mk-stacked
                :data="chartList"
                :options="chartOptions"
              >
              </mk-stacked>
            </template>
            <template v-else>
              <no-data v-if="!chartLoading"></no-data>
            </template>
          </div>
        </mk-card>
      </div>
      <div class="radar">
        <mk-card>
          <div
            slot="header"
            class="card-header"
          >
            <span>营销资料</span>
            <mk-dropdown
              class="select"
              @command="handleClick"
            >
              <mk-button-biz type="primary">
                {{ activeDropdown
                }}<i class="el-icon-caret-bottom el-icon--right"></i>
              </mk-button-biz>
              <mk-dropdown-menu slot="dropdown">
                <mk-dropdown-item command="one">
                  昨日访问量（PV）
                </mk-dropdown-item>
                <mk-dropdown-item command="two">
                  昨日访问线索（UV）
                </mk-dropdown-item>
                <!-- <mk-dropdown-item command="three">
                  昨日访问好友（UV）
                </mk-dropdown-item> -->
                <mk-dropdown-item command="four">
                  累计访问量（PV）
                </mk-dropdown-item>
                <mk-dropdown-item command="five">
                  累计访问线索（UV）
                </mk-dropdown-item>
                <!-- <mk-dropdown-item command="six">
                  累计访问好友（UV）
                </mk-dropdown-item> -->
              </mk-dropdown-menu>
            </mk-dropdown>
          </div>
          <div
            v-loading="materialRankListIsLoading"
            class="list-wrapper"
          >
            <ul v-if="materialRankList.length > 0">
              <li
                v-for="(item, index) in materialRankList"
                :key="index"
                class="radar-item"
              >
                <div class="radar-user-portrait">
                  <div
                    class="rank-circle"
                    :class="{
                      'rank-circle-one': index === 0,
                      'rank-circle-two': index === 1,
                      'rank-circle-three': index === 2
                    }"
                  >
                    {{ index + 1 }}
                  </div>
                </div>
                <div class="radar-info">
                  <div class="info-left">
                    <div class="user-action">
                      <!-- {{ item.name }} -->
                      <span class="material-type">{{
                        item.materialTypeCn
                      }}</span>{{ item.title }}
                    </div>
                    <div
                      v-if="item.tagInfo && item.tagInfo.length > 0"
                      class="user-tags"
                    >
                      <mk-tag
                        v-for="(tag, tagIndex) in item.tagInfo"
                        :key="tagIndex"
                      >
                        {{ tag.name }}
                      </mk-tag>
                      <span
                        v-if="item.countTags > 3"
                        class="tag-count"
                      >等{{ item.countTags }}个标签</span>
                    </div>
                  </div>
                  <div class="info-right">
                    <div class="info-right-count">
                      {{ item.attachCount }}
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <template v-else>
              <no-data v-if="!materialRankListIsLoading" />
            </template>
          </div>
        </mk-card>
      </div>
    </div>
    <div class="workbench-body-right">
      <div class="statistics">
        <mk-card>
          <div slot="header">
            <span>营销计划动态</span>
          </div>
          <no-data place-holder="即将上线，敬请期待" />
        </mk-card>
      </div>
    </div>
  </div>
</template>

<script>
import NoData from '@/components/no-data'
export default {
  name: 'MarketingView',
  components: {
    NoData
  },
  data () {
    return {
      // 统计数据是总数还是昨日
      dataType: 'all',
      // 图表的显示维度
      chartType: 'day',
      // 营销资料排行数据
      materialRankList: [1, 2],
      // 数据趋势图标数据
      chartList: [],
      // 当前的筛选条件
      activeDropdown: '昨日访问量（PV）',
      // 当前筛选条件
      sortField: 'yesterdayPV',
      // 简报数据
      briefingData: {},
      // 列表是否正在加载
      materialRankListIsLoading: false,
      // 数据趋势是否正在加载
      chartLoading: false,
      chartOptions: {
        chart: {
          height: 300,
          padding: [50, 60, 50, 60],
          scale: {
            time: {
              tickCount: 12
            }
          }
        },
        axis: [
          {
            name: 'time'
          },
          {
            name: 'attachCount'
          }
        ],
        geom: [
          {
            type: 'point',
            position: 'time*attachCount',
            color: 'type'
          },
          {
            type: 'line',
            position: 'time*attachCount',
            color: 'type'
          }
        ]
      }
    }
  },
  mounted () {
    this.initPageData()
  },
  methods: {
    // 初始化页面数据
    initPageData () {
      this.workbenchMarktingViewOverviewGet()
      this.workbenchMaterialTopGet()
      this.workbenchManageViewStatisticsGet()
    },
    // 查询简报
    async workbenchMarktingViewOverviewGet () {
      let res = await BIZAPIS.WorkbenchApi.workbenchMarktingViewOverviewGet()
      if (res.success) {
        this.briefingData = res.data
      }
    },
    // 查询营销资料列表
    async workbenchMaterialTopGet () {
      this.materialRankListIsLoading = true
      let res = await BIZAPIS.WorkbenchApi.workbenchMaterialTopGet({
        sortField: this.sortField
      })
      this.materialRankListIsLoading = false

      if (res.success) {
        let data = res.data ? res.data : []
        data.forEach(item => {
          item.materialTypeCn = this.materialFormat(item.materialType)
          item.tagInfo = item.tagInfo ? item.tagInfo : []
        })
        this.materialRankList = data
      }
    },
    // 查询数据趋势
    async workbenchManageViewStatisticsGet (statisticsType = 'day') {
      this.chartLoading = true
      let res = await BIZAPIS.WorkbenchApi.workbenchManageViewStatisticsGet({
        statisticsType
      })
      this.chartLoading = false
      if (res.success) {
        this.chartList = res.data ? res.data : []
      }
    },
    // 切换图表显示围度
    onChartTypeChange (val) {
      this.workbenchManageViewStatisticsGet(val)
    },
    handleClick (val) {
      this.activeDropdown = val
      this.filterDropdown(val)
      this.workbenchMaterialTopGet()
    },
    filterDropdown (val) {
      switch (val) {
        case 'one':
          this.activeDropdown = '昨日访问量（PV）'
          this.sortField = 'yesterdayPV'
          break
        case 'two':
          this.activeDropdown = '昨日访问线索（UV）'
          this.sortField = 'yesterdayUV'
          break
        case 'three':
          this.activeDropdown = '昨日访问好友（UV）'
          this.sortField = ''
          break
        case 'four':
          this.activeDropdown = '累计访问量（PV）'
          this.sortField = 'totalPV'
          break
        case 'five':
          this.activeDropdown = '累计访问线索（UV）'
          this.sortField = 'totalUV'
          break
        case 'six':
          this.activeDropdown = '累计访问好友（UV）'
          this.sortField = ''
          break

        default:
          break
      }
    },
    materialFormat (materialType) {
      switch (materialType) {
        case 'article':
          return '文章'
        case 'form':
          return '表单'
        case 'H5':
          return 'H5'
        case 'brochure':
          return '宣传册'
        case 'case':
          return '案例'
        case 'friend':
          return '朋友圈'
        case 'poster':
          return '海报'
        case 'video':
          return '视频'
        case 'video-markting':
          return '营销视频'
        default:
          return ''
      }
    }
  }
}
</script>
<style lang="scss">
.h-t-popover {
  font-size: 14px;
  color: #262626;
  line-height: 24px;

  span {
    font-size: 14px;
    line-height: 24px;
    font-weight: 500 !important;
  }
}
</style>
<style lang="scss" scoped>
.workbench-body {
  display: flex;
  min-height: 100%;

  .workbench-body-left {
    flex: 2;
    display: flex;
    flex-direction: column;

    .briefing,
    .radar,
    .chart {
      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }

    .briefing {
      .briefing-body {
        display: flex;
        justify-content: space-around;
        align-items: center;

        .briefing-item {
          display: flex;
          flex-direction: column;
          position: relative;
          text-align: center;

          .briefing-count {
            color: #262626;
            font-size: 20px;
            font-weight: 500;
            line-height: 38px;
          }

          .briefing-type {
            display: flex;
            margin-top: 7px;
            flex-direction: column;
            color: #8c8c8c;
            font-size: 13px;
            line-height: 22px;
          }
        }

        .line {
          display: block;
          width: 1px;
          height: 40px;
          background-color: #e9e9e9;
        }
      }
    }

    .chart {
      margin-top: 10px;
    }

    .radar {
      margin-top: 10px;
      height: 100%;

      .list-wrapper {
        height: 100%;
      }

      .mk-card {
        display: flex;
        flex-direction: column;
        height: 100%;
      }

      /deep/ .el-card__body {
        padding: 0;
        height: 100%;
      }

      .select {
        .el-button {
          padding: 10px 20px 11px;
          background-color: #f5f5f5;
          color: #595959;
          border: none;
        }

        .icon-arrow-down {
          color: #595959;
        }
      }

      .radar-item {
        padding: 0 40px 0 20px;
        height: 80px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        border-bottom: 1px solid #e8e8e8;

        .rank-circle {
          width: 24px;
          height: 24px;
          font-size: 13px;
          color: #fff;
          border-radius: 50%;
          line-height: 24px;
          text-align: center;
          background: #d9d9d9;
        }

        &:nth-child(1) .rank-circle {
          background:
            linear-gradient(
              180deg,
              rgba(254, 245, 88, 1) 0%,
              rgba(225, 164, 73, 1) 100%
            );
        }

        &:nth-child(2) .rank-circle {
          background:
            linear-gradient(
              180deg,
              rgba(254, 240, 207, 1) 0%,
              rgba(183, 183, 183, 1) 100%
            );
        }

        &:nth-child(3) .rank-circle {
          background:
            linear-gradient(
              180deg,
              rgba(242, 209, 128, 1) 0%,
              rgba(225, 164, 73, 1) 100%
            );
        }

        .radar-user-portrait {
          height: 36px;
          width: 36px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .radar-info {
          display: flex;
          flex: 1;
          margin-left: 10px;

          .info-left {
            flex: 1;

            .el-tag {
              height: 22px;
              line-height: 22px;
            }
          }

          .info-right {
            display: flex;
            align-items: center;
          }
        }

        .user-action,
        .action-time {
          font-size: 13px;
          line-height: 18px;
        }

        .user-action {
          color: #595959;
        }

        .material-type {
          display: inline-block;
          font-size: 12px;
          color: #009cff;
          padding: 2px 4px;
          border: 1px solid #009cff;
          margin-right: 6px;
        }

        .user-tags {
          margin-top: 8px;

          .tag-count {
            margin-left: 8px;
            font-size: 12px;
            color: #8c8c8c;
          }

          .mk-tag {
            border-radius: 2px;
            padding: 0 8px;
            background: rgba(235, 239, 244, 1);
            color: #6b7b88;
            border: none;
          }

          .el-tag + .el-tag {
            margin-left: 10px;
          }
        }

        .info-right-count {
          font-size: 16px;
          color: #595959;
        }
      }
    }
  }

  .workbench-body-right {
    flex: 1;
    margin-left: 10px;

    .statistics {
      height: 100%;

      .el-card {
        height: 100%;
      }

      /deep/ .el-card__body {
        height: calc(100% - 60px);
        box-sizing: border-box;
      }
    }
  }

  .h-title {
    .icon {
      font-size: 16px;
      color: #888;
      font-weight: normal;
    }
  }

  .h-t-popover {
    font-size: 14px;
    color: #262626;
    line-height: 24px;

    span {
      font-size: 14px;
      line-height: 24px;
      font-weight: 500;
    }
  }
}
</style>
